import Lenis from "https://cdn.jsdelivr.net/npm/lenis@1.1.20/dist/lenis.mjs";

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;
const designMode =
  typeof window.Shopify !== "undefined" && window.Shopify.designMode;

if (!reducedMotion && !designMode) {
  window.lenis = new Lenis({
    autoRaf: true,
    anchors: true,
    lerp: 0.12,
    wheelMultiplier: 1,
    touchMultiplier: 1,
  });
}
